import useStyles            from "./styles";
import BackgroundWrapper    from "_components/atoms/backgroundWrapper";
import Typography           from "_components/atoms/typography";
import Icon                 from "_components/atoms/icon";
import { useGetDeviceType } from "_common/hooks/global";
import { Button, Popover }  from "@mantine/core";

const component = ( {
	anchorEl,
	open,
	handleOpen,
	toggleMenuDialog,
	handleSettingsOpen,
	handleMarkAllRead
} ) => {

	const { classes } = useStyles ( { open } );
	const deviceType  = useGetDeviceType ();

	const isMobile = deviceType === "mobile";

	const renderOptions = () => {
		return (
			<>

				<div
					className = { classes.menuItem }
					onClick   = { () => {
						handleMarkAllRead ();
						toggleMenuDialog ();
					} }
				>

					<Icon
						className = { classes.svgIcon }
						name      = "notifSaveTick"
					/>

					<Typography
						className = { classes.iconText }
						title     = "Mark All Read"
					/>

				</div>

				<div
					className = { classes.menuItem }
					onClick   = { handleSettingsOpen }
				>

					<Icon
						className = { classes.svgIcon }
						name = "settings"
					/>

					<Typography
						className = { classes.iconText }
						title     = "Notification Settings"
					/>

				</div>
			</>
		);
	};

	return (
		<Popover
			closeOnClickOutside = { true }
			position = "bottom-end"
			shadow = "md"
			styles = { { dropdown: { background: "none", border: "none", boxShadow: "none" } } }
		>
			<Popover.Target>
				<Button unstyled
					bg = { "none" }
					style = { { border: "none" } }
				>
					{isMobile ? (
						<Icon
							className = { classes.settingsIcon }
							name      = "settings"
						/>
					) : (
						<Icon
							className = { classes.dotsIcon }
							name      = "menuDots"
						/>
					)}
				</Button>

			</Popover.Target>

			<Popover.Dropdown>
				<div>
					<BackgroundWrapper className = { classes.popperStyle }>
						{renderOptions ()}
					</BackgroundWrapper>
				</div>
			</Popover.Dropdown>
		</Popover>
	);
};

export default component;
